/* eslint-disable */
/* eslint-disable prefer-destructuring */
/* eslint-disable */
import SearchClient from '../search';

function groupDays(data) {
  const clasesRecurso = ['LINEA PRINCIPAL', 'LINEA BACKUP', 'ROUTER', 'ROUTER ADSL', 'ROUTER PRINCIPAL', 'ROUTER RESPALDO'];
  const listadoCIExcepcional = [
      'URGENCIAS',
      'MODULO GESTION DEL CONOCIMIENTO',
      'ESTACION CLINICA',
      'MODELO DE DATOS Y ETL DE MTI-ACCESIBILIDAD CONSULTAS EXTERNAS',
      'EG- ESTACION DE GESTION',
      'DIRAYA_COMPONENTES COMUNES DE LA CAPA CLIENTE',
      'ARIA CORPORATIVO',
      'RXXI PRESCRIPCIONES',
      'ESTACION CLINICA DE CUIDADOS',
      'FARMA HOSPITALES (ATHOS)',
      'PDI PRUEBAS DIAGNOSTICAS POR IMAGEN',
      'SERVICIO DE COMUNICACIONES WAN',
    ];
  const res = {};
  const formattedData = data.map((x) => {
    let date;
    let hour;
    let endDate;
    let affectedCI;
    let nombreRecursoDetalle;
    let auxDate;
    let auxDay;
    let auxMonth;
    let formattedDay;
    let formattedMonth;
    let auxHour;
    let auxMin;
    let fechaAperturaParada;
    let horaAperturaParada;
    let area = '';
    let localizacion = '';
    let ca_site_description;
    let referenciaPortal;

    if (x.CATEGORY === process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA) { // es parada
      const hasProps = x.PROPS.filter(p => p.ALIAS === 'fechaField' || p.ALIAS === 'fechaFinField' ); // eslint-disable-line
      if (hasProps.length <= 0) {
        return;
      }

      x.PROPS.forEach((prop) => {
        if (prop.ALIAS === 'applicationAffected') {
          affectedCI = prop.VALUE;
          nombreRecursoDetalle = prop.VALUE;
        }
        if (prop.ALIAS === 'fechaField' && prop.VALUE !== null) {
          const fecha = `${prop.VALUE }`;
          date = fecha.split(' a las ')[0];
          hour = fecha.split(' a las ')[1];
        }
        if (prop.ALIAS === 'fechaFinField' && prop.VALUE !== null) {
          auxDate = `${prop.VALUE}`;

          auxDay = auxDate.split(' a las ')[0];
          auxHour = auxDate.split(' a las ')[1];

          auxDate = auxDay.split('/');

          endDate = `${auxDate[0]}/${auxDate[1]} - ${auxHour}`;
        }
        const fechaDada = new Date(x.OPEN_DATE * 1000);

        const dia = fechaDada.getDate().toString().padStart(2, '0');
        const mes = (fechaDada.getMonth() + 1).toString().padStart(2, '0');
        const anio = fechaDada.getFullYear();
        const hora = fechaDada.getHours().toString().padStart(2, '0');
        const minuto = fechaDada.getMinutes().toString().padStart(2, '0');

        fechaAperturaParada = `${dia}/${mes}/${anio}`;
        horaAperturaParada = `${hora}:${minuto}`;

        if (prop.ALIAS === 'hospitalField' && prop.VALUE !== null) {
          area = prop.VALUE;
        }

        if (prop.ALIAS === 'REFERENCIA_PORTAL' && prop.VALUE !== null) {
          referenciaPortal = prop.VALUE;
        }
      });
    } else { // es incidencia
      // Si el tipo de recurso es alguno indicado, cambiar el titulo que aparece
      if(x.LOCALIZACION){
        localizacion = x.LOCALIZACION;
      }
      if (clasesRecurso.includes(x.TIPO_RECURSO.toUpperCase())) {
        affectedCI = `${x.TIPIFICACION.split('.').slice(1).join('.')} ${x.LOCALIZACION}`;
      } else {
        affectedCI = x.RESOURCE_NAME;
      }

      if (affectedCI && listadoCIExcepcional.includes(affectedCI)) {
        localizacion = x.CR_LOCALIZACION;
      }

      nombreRecursoDetalle = x.RESOURCE_NAME;
      auxDate = new Date(x.OPEN_DATE * 1000);
      auxDay = auxDate.getDate();
      auxMonth = auxDate.getMonth() + 1;

      formattedDay = auxDay < 10 ? `0${auxDay}` : auxDay;
      formattedMonth = auxMonth < 10 ? `0${auxMonth}` : auxMonth;
      date = `${formattedDay}/${formattedMonth}/${auxDate.getFullYear()}`;

      auxHour = auxDate.getHours() < 10 ? `0${auxDate.getHours()}` : auxDate.getHours();
      auxMin = auxDate.getMinutes() < 10 ? `0${auxDate.getMinutes()}` : auxDate.getMinutes();
      hour = `${auxHour}:${auxMin}`;
      endDate = '';

      if(x.CA_SITE_DESCRIPTION) {
        ca_site_description = x.CA_SITE_DESCRIPTION.replace(/^\s*\d+\s*/, '');
      }
    }
    return { // eslint-disable-line
      category: x.CATEGORY,
      priority: x.PRIORITY,
      description: x.DESCRIPTION,
      affectedCI,
      date,
      hour,
      endDate,
      fechaAperturaParada,
      horaAperturaParada,
      REF_NUM: x.REF_NUM,
      persid: x.PERSID,
      status: x.STATUS,
      type: x.TYPE,
      children: x.ZINCS_IMPACTO,
      area,
      reclamaciones: x.ZRECLAMACIONES,
      centralizada: x.CENTRALIZADA,
      nodoId: x.NODO_ID,
      parent: x.PARENT,
      tipoRecurso: x.TIPO_RECURSO,
      nombreRecursoDetalle,
      localizacion,
      ca_site_description,
      referenciaPortal,
    };
  });

  const clean = formattedData.filter((f) => f !== null && f !== undefined);
  clean.sort((a, b) => {
    let [horaA, minutoA] = a.hour.split(':');// eslint-disable-line
    let [horaB, minutoB] = b.hour.split(':');// eslint-disable-line

    horaA = parseInt(horaA);// eslint-disable-line
    horaB = parseInt(horaB);// eslint-disable-line

    if (horaA !== horaB) {
      return horaA - horaB;
    }
    return parseInt(minutoA) - parseInt(minutoB);// eslint-disable-line
  });

  clean.forEach((x) => {
    const { date } = x;
    if (!res[date]) {
      res[date] = [x];
    } else {
      res[date].push(x);
    }
  });

  return res;
}

export default class SolicitudesClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  getParadas = async (filters) => {
    try {
      const response = await this.request('get')(
        {
          CATEGORY: filters.category,
          STATUS_PARADA: filters.statusParada,
          STATUS_INCIDENCIA: filters.statusIncidencia,
          USER_NODO: filters.userNodo,
        },
        { path: 'solicitudes/paradas' },
      );
      return groupDays(response.data.collection_cr_prp.cr_prp);
    } catch (error) {
      return error.response;
    }
  }

  getSandetel = async (filters) => {
    try {
      const response = await this.request('get')(
        {
          STATUS_INCIDENCIA: filters.statusIncidencia,
        },
        { path: 'solicitudes/sandetel' },
      );

      return response.data.collection_cr_prp.cr_prp;
    } catch (error) {
      return error.response;
    }
  }

  getMap = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: '/global/mapas' },
      );

      return response;
    } catch (error) {
      return error.response;
    }
  }

  async rate({
    valoracion,
    comment,
    id,
    name,
    uuid,
    username,
    dni,
    codigo,
    canal,
  }) {
    const body = {
      data: {
        canal: {
          id: canal,
        },
        usuario: {
          uuid,
          usuario: username,
          dni,
        },
        objeto: {
          codigo,
          id,
        },
        pregunta: name,
        valoracion,
        comentario: comment,
      },
      apiCges: {
        delegado: username,
        endpoint: 'cges/valoraciones',
      },
    };

    try {
      const response = await this.request('post', 'rate')({ body }, {
        path: 'solicitudes',
      });

      console.log('rate response', response);
      return response;
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async getMotives() {
    
     try {
      const response = await this.request('get')(
        {
          apiCges: {
            endpoint: 'cges/tablas/knowledgeitems/valoraciones/motivos'
          },
        },
        { path: 'solicitudes/motivos' },
      );

      return response;
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async getTypeBussiness() {
     try {
      const response = await this.request('get')(
        {
          STATUS_INCIDENCIA: filters.statusIncidencia,
        },
        { path: 'solicitudes/sandetel' },
      );

      return response.data.collection_cr_prp.cr_prp;
    } catch (error) {
      return error.response;
    }
  }

  async getReferenciaPortal(referenciaPortal) {
     try {
      const data = {
          apiCges: {
            endpoint: `cges/portal/noticias/${referenciaPortal}`,
          },
        };
      const response = await this.request('get')(
        { data },
        { path: '/solicitudes/referenciaPortal' },
      );

      return response;
    } catch (ex) {
      throw this.handleError(ex);
    }
  }
}
